import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { scrollToId } from './home/homeData';

const CALENDLY = 'https://calendly.com/yovel-yovaiagency/new-meeting';

const FOOTER_INDUSTRIES = [
  { id: 'hvac', name: 'HVAC', action: 'Primary Focus' },
  { id: 'dental', name: 'Dental Practices', action: 'Explore A Custom Build' },
  { id: 'medspa', name: 'Med Spas', action: 'Explore A Custom Build' },
  { id: 'roofing', name: 'Roofing Companies', action: 'Explore A Custom Build' },
  { id: 'other', name: 'Other Service Businesses', action: 'Let\u2019s Talk' },
];

const FooterIndustries = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const pick = (id) => {
    if (pathname === '/') {
      window.dispatchEvent(new CustomEvent('yv:industry', { detail: id }));
      scrollToId('contact');
      return;
    }
    sessionStorage.setItem('yv-industry', id);
    navigate('/#contact');
  };
  return (
    <ul className="space-y-2">
      {FOOTER_INDUSTRIES.map((n) => (
        <li key={n.id}>
          <button onClick={() => pick(n.id)} className="footer-ind-link" data-testid={`footer-industry-${n.id}`}>
            <span className="footer-ind-name">{n.name}</span>
            <span className="footer-ind-action">{n.action}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};

const SiteFooter = () => (
  <footer className="site-footer">
    <div className="max-w-[1280px] mx-auto px-6 md:px-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-10">
        <div className="lg:col-span-2">
          <img src="/yovai-logo.png" alt="YOVAI" className="h-10 mb-4" />
          <p className="text-white/50 text-sm max-w-sm">
            YOVAI Builds Business Communication &amp; Automation Systems That Help Service
            Businesses Follow Up Faster, Keep Inquiries Organized, And Give Their Teams Clear
            Visibility.
          </p>
        </div>
        <div>
          <h4>Systems</h4>
          <ul className="space-y-2">
            <li><a href="/#journey" data-testid="footer-workflow">How It Works</a></li>
            <li><a href="/#solutions" data-testid="footer-solutions">Solutions</a></li>
            <li><a href="/#systems" data-testid="footer-systems">Service Packages</a></li>
            <li><a href="/#estimator" data-testid="footer-estimator">Opportunity Estimator</a></li>
          </ul>
        </div>
        <div>
          <h4>Industries</h4>
          <FooterIndustries />
        </div>
        <div>
          <h4>Company</h4>
          <ul className="space-y-2">
            <li><a href="/#process" data-testid="footer-process">Our Process</a></li>
            <li><a href="/#contact" data-testid="footer-contact">Apply For A Consultation</a></li>
            <li><Link to="/support" data-testid="footer-support">Support</Link></li>
            <li><a href={CALENDLY} target="_blank" rel="noopener noreferrer" data-testid="footer-calendly">Book A Discovery Call</a></li>
            <li><a href="/#faq" data-testid="footer-faq">FAQ</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-compliance">
        <div className="footer-compliance-col">
          <h4>Contact</h4>
          <ul className="space-y-2">
            <li><a href="tel:+14702980440" data-testid="footer-phone">(470) 298-0440</a></li>
            <li><a href="mailto:yovel@yovaiagency.com" data-testid="footer-email">yovel@yovaiagency.com</a></li>
          </ul>
        </div>
        <div className="footer-compliance-col">
          <h4>Legal</h4>
          <ul className="space-y-2">
            <li><Link to="/terms" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/sms-terms" data-testid="footer-sms-terms">SMS Terms</Link></li>
            <li><Link to="/cancellation-refunds" data-testid="footer-cancel">Cancellation and Refund Policy</Link></li>
            <li><Link to="/safety" data-testid="footer-safety">Safety and Responsible AI</Link></li>
            <li><Link to="/dpa" data-testid="footer-dpa">Data Processing Addendum</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-brand">YOVAI LLC</div>
        <div className="footer-bottom-tag">Business Communication &amp; Automation Systems</div>
        <div className="footer-bottom-meta">Based in Atlanta, Georgia. Serving businesses nationwide.</div>
        <div className="footer-bottom-copy">&copy; 2026 YOVAI LLC. All rights reserved.</div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
